export default __webpack_public_path__ + "static/media/KegstarLogo_Star.7db82fbc.svg";